import _ from "lodash";
import { CxSecurityGroupDetailsDto } from "@lib/ShiOneClient";

export const getManagedSecurityGroups = (
  myUserId: string | undefined,
  teamsList: CxSecurityGroupDetailsDto[] | undefined
): CxSecurityGroupDetailsDto[] => {
  if (!myUserId) return [];
  return _.filter(teamsList, (team) =>
    _.some(
      team.members,
      (member) => member.userId === myUserId && member.canEditSecurityGroup
    )
  );
};

export const getSecurityGroups = (
  myUserId: string | undefined,
  teamsList: CxSecurityGroupDetailsDto[] | undefined
): CxSecurityGroupDetailsDto[] => {
  if (!myUserId) return [];
  return _.filter(teamsList, (team) =>
    _.some(team.members, (member) => member.userId === myUserId)
  );
};

interface Permissions {
  teamId: number;
  grantedPermissions: string[];
}

export const changeSecurityGroupPermissions = (
  currentPermissions: Permissions,
  permissions: string[],
  allow: boolean
): Permissions => {
  const granted = new Set(currentPermissions.grantedPermissions ?? []);

  permissions.forEach((permission) => {
    if (allow) {
      granted.add(permission);
    } else {
      granted.delete(permission);
    }
  });

  // The write endpoint only consumes teamId + grantedPermissions; the response re-populates
  // the full editor shape, so there is no need to echo resourceDefinitions back on save.
  return {
    teamId: currentPermissions.teamId,
    grantedPermissions: Array.from(granted),
  };
};

export const getAcronym = (name: string | null | undefined) => {
  if (name && name.length > 0 && /\S/.test(name)) {
    const acronym = name.match(/\b(\w)/g);
    return acronym && acronym.length > 2 ? acronym.slice(0, 2) : acronym ?? "NA";
  }
  return "NA";
};

export const checkSecurityGroupContracts = (
  myTeams: CxSecurityGroupDetailsDto[] | undefined,
  contractId: number
): boolean => {
  return _.some(myTeams, (team) => {
    return _.some(
      team.contracts,
      (contract) => contract.contractId === contractId
    );
  });
};
